// https://stackoverflow.com/questions/14650932/set-value-to-currency-in-input-type-number

// Define the plugin immediately on window.jQuery
(function($) {
  $.fn.currencyInput = function() {
    this.each(function() {
      var wrapper = $("<div class='currency-input' />");
      $(this).wrap(wrapper);
      $(this).before("<span class='currency-symbol'>$</span>");
      $(this).change(function() {
        var value = $(this).val().replace(/[$,]+/g,"");
        $(this).val( Number(value).toFixed(2) );
      });
    });
  };
})(window.jQuery);

// Initialize on document ready
// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;
$(document).ready(function() {
  $('input.currency').currencyInput();
});

// Re-initialize on turbo events
$(document).on('turbo:load turbo:frame-render', function() {
  $('input.currency').currencyInput();
});
